<style scoped>
#navbar {
    padding: 0 .7em;
    background: rgb(103, 103, 103);
    background: linear-gradient(180deg, rgba(103, 103, 103, 1) 0%, rgba(14, 14, 14, 1) 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#navbar i {
    font-size: 21px;
}

.icon-navbar {
    text-decoration: none !important;
    padding: 18px 10px 5px 10px;
}

.logo {
    background: url("@/assets/Logo_Gesware_V2_white.png") no-repeat;
    background-size: 40px auto;
    display: inline-block;
    padding-left: 50px;
    margin-right: 2em;
    text-decoration: none;
    background-position-y: center;
    padding-bottom: .5em !important;
}

#navbar .navbar-selected:not(.dropdown-item) {
    background: linear-gradient(to bottom, #525657 0%,#000000 85%)!important;
}

.website-info {
    padding-top: .5em !important;
}

.website-info p {
    font-size: 14px;
    margin: 0;
}

.gesware-version {
    font-size: small;
    font-weight: bold;
    text-align: center;
}

.gesware-version p {
    font-size: x-small;
    font-weight: bold;
}

.span-text {
    display: inline-block;
    font-weight: bold;
    font-size: 24px;
}

img {
    vertical-align: unset;
    display: inline-block;
    height: auto;
}
.section-div {
    border-top: 2px solid rgba(114, 114, 114, 0.76);
    margin: 10px 0;
}
</style>

<template>
    <div>
        <div id="navbar">
                <router-link to="/" class="logo">
                    <div class="text-white website-info">
                        <div class="gesware-version">
                            Ge$ware
                            <p :class="{'text-green': !IS_PROD}" >{{ APP_VERSION }}</p>
                        </div>
                    </div>
                </router-link>

            <div>
                <div class="icon-general icon-navbar">
                    <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa-solid fa-bars"></i>
                    </button>
                    <div class="dropdown-menu dropdown divide-y divide-gray-100">
                        <ul class="text-start pl-0 mb-0">
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_Home'}">
                                    <i class="fa-solid fa-clock "></i>
                                    Entrée de Temps
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_ExpenseForm'}" v-if="hasPermission('mobile_ExpenseForm')">
                                    <i class="fa-solid fa-user"></i>
                                    Dépenses
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_AllowanceForm'}" v-if="hasPermission('mobile_AllowanceForm')">
                                    <i class="fa-regular fa-money-bill-1"></i>
                                    Allocations
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_Timesheet'}" v-if="hasPermission('mobile_Timesheet')">
                                    <i class="fa-solid fa-lock"></i>
                                    Feuille de temps
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_EmployeInOut'}" v-if="hasPermission('mobile_EmployeInOut')">
                                    <i class="fa fa-building-user"></i>
                                    Présence
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'mobile_Contact Book'}" v-if="hasPermission('mobile_Contact Book')">
                                    <i class="fa-solid fa-address-book "></i>
                                    Contact
                                </router-link>
                            </li>

                            <li class="section-div"></li>
                            <li>
                                <a class="dropdown-item" @click="logout()">
                                    <i class="fa-solid fa-power-off"></i>
                                    Déconnecter
                                </a>  
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useAuthUserStore } from "@/store/auth.js";
    import { usePermissionStore } from '@/store/perms.js';
    import UpdateCountdown from "@/components/navbar/UpdateCountdown.vue";

    export default {
        name: 'mobile_Navbar',
        components: { UpdateCountdown },
        data() {
            return {
                useAuthUserStore: useAuthUserStore(),
                usePermissionStore: usePermissionStore(),
            }
        },
        computed: {
            APP_VERSION() {
                return `v5 (${import.meta.env.VITE_APP_VERSION})`;
            },
            IS_PROD() {
                return import.meta.env.VITE_APP_ENV === "laravel";
            },
        },
        methods: {
            logout () {
                this.useAuthUserStore.logout().then(() => {
                    this.$router.push({name: 'Login'});
                });
            },
            hasPermission(routeLink) {
                const route = this.$router.options.routes.find(route => route.name === routeLink);
                const metadata = route && route.meta;
                return !(metadata.permission_requirement !== undefined && !this.usePermissionStore.canAccess(metadata.permission_requirement))
            },
        }
    }
</script>